import PropTypes from 'prop-types';
import React from 'react';
import Nav from 'react-bootstrap/lib/Nav';
import NavDropdown from 'react-bootstrap/lib/NavDropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';

import { browserHistory } from 'shared/constants';

import noUserImage from 'assets/images/no-user-image.gif';

const userAvatar = (
  <div className="user-avatar-crop">
    <img className="user-avatar" alt="" src={noUserImage} />
  </div>
);

// eslint-disable-next-line import/no-default-export
export default class UserDropdown extends React.Component {
  static contextTypes: any;
  static propTypes: any;

  render() {
    const { isAllowedOperation } = this.context;
    const { email, displayName, dispatchSignOut, links } = this.props as any;
    const allowedLinks = links.filter(({ permission }) => isAllowedOperation(permission));

    return (
      <Nav className="pull-right">
        <NavDropdown id="nav-dropdown-user" eventKey="sign-out" className="sign-out-btn" title={userAvatar}>
          <MenuItem key="user" eventKey="user">
            <div className="media">
              <div className="media-left">{userAvatar}</div>
              <div className="media-body">
                <h3 className="media-heading">{displayName}</h3>
                <p>{email}</p>
              </div>
            </div>
          </MenuItem>

          {allowedLinks.map(({ isExternalLink, pathname, icon, label }) => (
            <MenuItem key={pathname} eventKey="company-options">
              <button
                type="button"
                className="btn btn-sm btn-block btn-tool-box"
                style={{ textAlign: 'left' }}
                onClick={() => {
                  if (isExternalLink) {
                    window.location.replace(pathname);
                    return;
                  }
                  browserHistory.pushPatched({ pathname });
                }}
              >
                <i className={icon} />
                {label}
              </button>
            </MenuItem>
          ))}

          <MenuItem key="sign-out" eventKey="sign-out">
            <div className="popover-btn-line">
              <button
                type="button"
                onClick={() => {
                  dispatchSignOut(true);
                }}
                className="btn btn-sm btn-danger pull-right"
              >
                {translate('Sign out')}
              </button>

              <div className="clearfix" />
            </div>
          </MenuItem>
        </NavDropdown>
      </Nav>
    );
  }
}

UserDropdown.contextTypes = {
  isAllowedOperation: PropTypes.func.isRequired,
};

UserDropdown.propTypes = {
  links: PropTypes.array.isRequired,
  email: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  dispatchSignOut: PropTypes.func.isRequired,
};
